module.exports = __webpack_public_path__ + "img/bianyazhan.075a42e6.png";